import React, { useEffect, useState } from 'react';

interface UsePortalVisible {
  rfqId: string;
  chatRoomId: string;
  matches: boolean;
}

const usePortalVisible = ({
  matches,
  rfqId,
  chatRoomId
}: UsePortalVisible): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>
] => {
  const [visible, setVisible] = useState(false);

  /*
    Portal 렌더링 결정 
  */
  useEffect(() => {
    if (!matches) {
      setVisible(false);
    }

    if (matches && (rfqId || chatRoomId)) {
      setVisible(true);
    }
  }, [matches, rfqId, chatRoomId]);

  return [visible, setVisible];
};

export default usePortalVisible;
